import { defineMessages } from 'react-intl';

export default defineMessages({
    activationFailedTitle: {
        id: 'agent.registration.activation.User Activation Failed Title',
        defaultMessage: 'Invalid Activation'
    },
    activationFailedBody: {
        id: 'agent.registration.activation.User Activation Failed Body',
        defaultMessage: 'The information you entered does not match our records. Please try again.'
    },
    activationLockoutBody: {
        id: 'agent.registration.activation.User Activation Lockout Body',
        defaultMessage: 'You have exceeded the maximum number of allowed attempts. Please try again after 10 minutes.'
    }
});
